const TOASTER_DATA = 'TOASTER_DATA'

export default TOASTER_DATA